export class factory_map {
    constructor() {
       
        var lastOpened;
        
        
        jQuery('.anchor').click(function () {
        
          if (jQuery(".plan-section").css("position") == "absolute") {
            if (lastOpened) {
              if (lastOpened != this) {
                closeBox(lastOpened);
                setTimeout(openBox, 350, this);
              }
            } else {
              openBox(this)
            }
            lastOpened = this;
          }
        
        })
        jQuery('.section-info .close').click(function () {
          lastOpened = null;
          closeBox(this);
        })
        
        function openBox(thisObj) {
          jQuery(thisObj).closest('.plan-section').addClass('opening');
          jQuery('.section-info').bind("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function () {
            jQuery(this).closest('.plan-section').removeClass('opening');
            jQuery(this).closest('.plan-section').addClass('open');
          })
        }
        
        function closeBox(thisObj) {
          jQuery(thisObj).closest('.plan-section').addClass('closing');
          jQuery('.anchor').bind("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function () {
            jQuery(this).closest('.plan-section').removeClass('closing');
            jQuery(this).closest('.plan-section').removeClass('open');
          })
        }
     
    }
}